const environment = {

  //apiUrl: "https://jarvisconnectwebapi.azurewebsites.net/api/v4/", //Dev
  //apiUrlVFive: "https://jarvisconnectwebapi.azurewebsites.net/api/v5/", //Dev
  apiUrl:"https://seedwebapi.azurewebsites.net/api/v1/", //Production
  apiUrlV4: "https://seedwebapi.azurewebsites.net/api/v4/",
  apiUrlV6: "https://seedwebapi.azurewebsites.net/api/v6/",
  //apiUrl: "http://localhost:42000/api/v4/",
  //apiUrlVFive: "http://localhost:42000/api/v5/" //Dev
 // customerwebUrl: "https://fusionseedweb.azurewebsites.net/login" //Dev Customer Web for Registrartion
 customerwebUrl: "https://seedcustomer.seedkm.com", //Dev Customer Web for Registrartion
 thankyouUrl:"https://seedkm.com/thank-you",
 thankyouenUrl:"https://seedkm.com/en/thank-you",
 thankyouviUrl:"https://seedkm.com/vi/thank-you"
};

export default environment;
